import RecentlyCompletedSection from './RecentlyCompletedSection'

export default RecentlyCompletedSection
